import { atom } from "jotai";
// TODO: Migrate to Cloudflare D1/R2/Workers
// import type { User } from "firebase/auth";
type User = {
  uid: string;
  email: string | null;
  displayName: string | null;
  photoURL: string | null;
  emailVerified: boolean;
  isAnonymous: boolean;
};

/** Currently signed in user. `undefined` means loading. */
export const currentUserAtom = atom<User | null | undefined>(undefined);

/** User roles from Clerk publicMetadata */
export const userRolesAtom = atom<string[]>([]);
